import React from "react";
import styles from "./styles.module.scss";
import { classNames } from "src/shared/lib/classNames/classNames";

const MainTitle = ({ text, className }) => {
  return <h2 className={classNames(styles.main_title, {}, [className])}>{text}</h2>;
};

export default MainTitle;
